import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
export const CONSENT_KEY = "cc-cookie-consent";

export function hasConsent() {
  return localStorage.getItem(CONSENT_KEY) === "granted";
}

export function loadGA() {
  if (!GA_ID || window.__gaLoaded) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.__gaLoaded = true;
  window.gtag("event", "page_view", { page_path: window.location.pathname, page_title: document.title });
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
}

function classifyLink(a) {
  const href = a.getAttribute("href") || "";
  if (href.startsWith("tel:")) return "phone_click";
  if (href.includes("wa.me")) return "whatsapp_click";
  if (href.startsWith("mailto:")) return "email_click";
  if (href.endsWith("#calculator")) return "calculator_cta_click";
  return null;
}

// Laadt GA4 alleen met toestemming; stuurt page_views bij SPA-navigatie en conversie-klikken.
const Analytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (hasConsent()) loadGA();
  }, []);

  useEffect(() => {
    if (!window.__gaLoaded) return;
    const t = setTimeout(() => trackEvent("page_view", { page_path: pathname, page_title: document.title }), 50);
    return () => clearTimeout(t);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const name = classifyLink(a);
      if (name) trackEvent(name, { page_path: window.location.pathname, label: a.textContent.trim().slice(0, 60) });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
};

export default Analytics;
